<template>
<div class='loading'>
	<img src="@/assets/loading.gif" alt="Loading..." height="70" width="90">
	</div>
</template>

<script>
export default {
  name: 'LoadingComponent',
  props: {
  },
  data: function() {
return {
  };
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
